import { useQuery } from '@tanstack/react-query'
import { IndividualPostsResponse } from 'src/services/__generated__/api'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ContentAnalysisApiService } from 'src/services/contentAnalysisApi'

interface UseGetContentAnalysisIndividualPostsQueryParams {
  fromDate?: string
  id: string
  limit?: number
  page?: number
  platform?: string
  toDate?: string
}

export const useGetContentAnalysisIndividualPostsQuery = ({
  fromDate,
  id,
  limit,
  page,
  platform,
  toDate,
}: UseGetContentAnalysisIndividualPostsQueryParams) => {
  return useQuery({
    enabled: !!id,
    queryFn: () =>
      ContentAnalysisApiService.getIndividualPosts<IndividualPostsResponse>(
        id,
        { fromDate, limit, page, platform, toDate }
      ),
    queryKey: [
      QueryKey.GET_CONTENT_ANALYSIS_INDIVIDUAL_POSTS,
      id,
      platform,
      page,
      limit,
      fromDate,
      toDate,
    ],
  })
}
